// npm i react-qr-code
import { Box, Typography } from "@mui/material";
import { useState } from "react";
import ShowQRCode from "../subComponent/ShowQRCode";
import AdminHeaderComp from "../subComponent/AdminHeaderComp";

const AddDataToQRCode = () => {
    const [qrData, setQrData] = useState("");
    
    return(
        <Box sx={{display: "flex", flexDirection:"column", alignItems:"center", gap:"1rem",}}>
            <AdminHeaderComp />
            <Typography>Enter URL</Typography>
            <input type="text" value={qrData} onChange={(e)=>setQrData(e.target.value)}/>
            <ShowQRCode qrData={qrData} />
        </Box>
    )
}
export default AddDataToQRCode;